/* unplugin-vue-components disabled */import script from "./Medal.vue?vue&type=script&setup=true&name=Medal&lang=js"
export * from "./Medal.vue?vue&type=script&setup=true&name=Medal&lang=js"

import "./Medal.vue?vue&type=style&index=0&id=2d537417&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d537417"]])

export default __exports__